import React, { createContext, ReactNode, useEffect, useState } from 'react';
import useStore from '../components/Hooks/useStore';
import useValiditiesController from '../components/Page/Validity/Validities/useValiditiesController';
import Modal from '../components/Modal';
import useStatusController from '../components/Page/Validity/Status/useStatusController';

type ValidityContextType = {
  controllers: {
    validity: ReturnType<typeof useValiditiesController>;
    status: ReturnType<typeof useStatusController>;
  };
};

export const ValidityContext = createContext<ValidityContextType | null>(null);

type ValidityProviderProps = {
  children: ReactNode;
};

export const ValidityProvider: React.FC<ValidityProviderProps> = ({
  children,
}) => {
  const validitiesController = useValiditiesController();
  const statusController = useStatusController();

  const [getters, setters] = useStore();
  const {
    searchFilter: validitiesSearchFilter,
    loadingValidities,
    setLoadingValidities,
  } = validitiesController;
  const { searchFilter: statusSearchFilter } = statusController;
  const {
    modal: { getModal },
  } = getters;

  const {
    auth: { getKibanaToken },
    validity: { filterValidities, filterValidityStatus },
  } = setters;
  const [authenticated, setAuthenticated] = useState(true);

  // useEffect(() => {
  //   getKibanaToken().then(() => {
  //     setAuthenticated(true);
  //   });
  // }, []);

  let validitiesSearchTimerId: NodeJS.Timeout;
  useEffect(() => {
    const handleInputChange = () => {
      clearTimeout(validitiesSearchTimerId);
      validitiesSearchTimerId = setTimeout(() => {
        setLoadingValidities(true);
        filterValidities().finally(() => {
          setLoadingValidities(false);
        });
      }, 500);
    };
    handleInputChange();
    return () => {
      clearTimeout(validitiesSearchTimerId);
    };
  }, [validitiesSearchFilter, setLoadingValidities]);

  let statusSearchTimerId: NodeJS.Timeout;
  useEffect(() => {
    const handleInputChange = () => {
      clearTimeout(statusSearchTimerId);
      statusSearchTimerId = setTimeout(() => {
        filterValidityStatus();
      }, 500);
    };
    handleInputChange();
    return () => {
      clearTimeout(statusSearchTimerId);
    };
  }, [statusSearchFilter]);

  return (
    <ValidityContext.Provider
      value={{
        controllers: {
          validity: validitiesController,
          status: statusController,
        },
      }}
    >
      {authenticated ? children : null}
      {getModal('single.createValidity') ? (
        <Modal.Validity.Validity.Create />
      ) : null}
      {getModal('single.updateValidity') ? (
        <Modal.Validity.Validity.Update />
      ) : null}
      {getModal('single.filterValidity') ? (
        <Modal.Validity.Validity.Filter />
      ) : null}
      {getModal('single.deleteValidity') ? (
        <Modal.Validity.Validity.Delete />
      ) : null}
      {getModal('single.createStatus') ? (
        <Modal.Validity.Status.Create />
      ) : null}
      {getModal('single.updateStatus') ? (
        <Modal.Validity.Status.Update />
      ) : null}
      {getModal('single.filterStatus') ? (
        <Modal.Validity.Status.Filter />
      ) : null}
      {getModal('single.deleteStatus') ? (
        <Modal.Validity.Status.Delete />
      ) : null}
    </ValidityContext.Provider>
  );
};
